/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { lazy } from 'react';

// Split point keeping the feedback screens out of every consumer's shared
// bundle. Jest maps this to the eager component (see jest.config.js).
//
// Imported by the package's own subpath rather than './Feedback': consumers on
// moduleResolution nodenext (home, account-web, home-web, snap-web, ...) type
// check this source, and there a relative import() needs an explicit file
// extension (TS2835) that Metro then cannot resolve back to the .tsx. A bare
// specifier has no such requirement.
export default lazy(async () => {
  const { Feedback } = await import('@airasia-rn/nps/feedback-page');
  return { default: Feedback };
});
